import { register } from "@shopify/theme-sections";
import * as React from "react";
import * as ReactDOM from "react-dom";
import StoresPage from "../components/Stores/StoresPage";

register("stores", {
  onLoad() {
    ReactDOM.render(
      React.createElement(StoresPage, {
        stores: window.stores.stores,
      }),
      document.getElementById("stores-dom"),
    );
  },
});
